module.exports = "<app-inteclia-table\n  [columns]=\"columnsDisplay\"\n  [key]=\"'reclamation'\"\n  [ActiveSelectd]=\"true\"\n  [header]=\"true\"\n  [width]=\"router.url\">\n</app-inteclia-table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/traitementmasse/traitementmasse.component.html
// module id = ./src/app/view/traitementmasse/traitementmasse.component.html
// module chunks = main